'use strict';

import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import classNames from 'classnames';
import { actions as notify } from 'redux-notifications';
import { pureFilter } from '../../../utils/urls';
import Checkbox from '../Checkbox';

import { saveSearchFilter } from '../../../app/Search/actions';
import { SUCCESS, SAVED_FILTER_VERSION } from '../../../consts';
import { SEARCH_FILTER } from '../../../app/Search/actionTypes';
import {showAuthModal as showAuthForm} from '../../../app/Auth/actions';
import { IconSaveSearch } from '../../Icons';

class CreateSearchForm extends Component {
  constructor (props) {
    super(props);

    this.state = {
      isOpen: false,

      name: '',
      email: props.user.getIn(['data', 'email']) || '',
      checked: true,
      name_error: null,
      email_error: null,
      process: false
    };

    this.handlerOpen = this.handlerOpen.bind(this);
    this.handlerClose = this.handlerClose.bind(this);
    this.handlerSave = this.handlerSave.bind(this);
  }

  handlerOpen () {
    this.props.eventOnOpen();

    const userId = this.props.user.getIn(['data', 'id'], null) || null;

    if (userId) {
      this.setState({
        isOpen: true
      });
    } else {
      this.props.showAuthForm('Для сохранения поиска необходимо авторизоваться или зарегистрироваться. <br /><br />' +
          'Это позволит в любой момент и на любых Ваших устройствах вернуться к текущим результатам поиска.');
    }
  }

  handlerClose (e) {
    e.preventDefault();
    e.stopPropagation();
    this.setState({
      isOpen: false,
      name_error: null,
      email_error: null
    });
  }

  handlerSave (e) {
    const state = {};
    const name = this.state.name.trim();
    const email = this.state.email.trim();
    let process = true;

    if (!name.length) {
      state.name_error = 'Необходимо заполнить поле «Название поиска».';
      process = false;
    }

    if (this.state.checked && !email) {
      state.email_error = 'Необходимо заполнить поле «EMail».';
      process = false;
    }

    state.process = process;
    this.setState(state);

    if (process) {
      const {user, section, domain, filter} = this.props;
      const userId = user.getIn(['data', 'id']);

      this.props.saveSearchFilter(userId, {
        formatVersionId: SAVED_FILTER_VERSION,
        dealType: section.get('dealType'),
        realtyType: section.get('realtyType'),
        filter: JSON.stringify(pureFilter(filter).set('regionId', domain.get('regionId')).toJSON()),
        regionId: domain.get('regionId'),
        name: name,
        subscribe: this.state.checked ? 1 : null,
        email: this.state.checked && email
      }).then((action) => {
        const state = {
          name_error: null,
          email_error: null,
          process: false
        };

        if (action.type === SEARCH_FILTER + SUCCESS) {
          state.name = '';
          state.isOpen = false;
          this.props.sendNotify({ message: 'Поиск успешно сохранен', dismissAfter: 3000 });
          if (this.state.checked) {
            this.props.eventSubscriptionForCian();
          }
        } else {
          action.payload && action.payload.map(err => {
            state[err.field + '_error'] = err.message;
          });
        }

        this.setState(state);
      });
    }
  }

  render () {
    const { isOpen, process } = this.state;
    const modalClass = classNames('modal full-screen', {
      'open fade in': isOpen
    });

    return (
      <Fragment>
        <span className='link-base saved-search' onClick={this.handlerOpen}>
          <IconSaveSearch />
            Сохранить поиск
        </span>

        <div className={modalClass}>
          <div className='modal-dialog full-screen'>
            <div className='modal-content animate-top'>
              <div className='modal-box save-search-modal'>
                <button type='button' className='close' onClick={this.handlerClose}>×</button>
                {
                  isOpen && (
                    <div className='form-container'>
                      <h2 className='header'>Сохранить поиск</h2>
                      <div className='mute-description'>
                        Это позволит в любой момент и на любых Ваших устройствах вернуться к текущим результатам поиска
                      </div>

                      <div className='form'>
                        <div className={'name-box' + (this.state.name_error ? ' error' : '')}>
                          <input
                            type='text'
                            className='text-base'
                            value={this.state.name}
                            placeholder='Введите название поиска'
                            onChange={(e) => this.setState({name: e.target.value})}
                          />
                          <span className='error-message'>{this.state.name_error}</span>
                        </div>

                        <Checkbox
                          label='Присылать новые объявления на email'
                          checked={this.state.checked}
                          onUpdate={(_, state) => this.setState({checked: state})}
                        />

                        {
                          this.state.checked && (
                            <div className={'email-box' + (this.state.email_error ? ' error' : '')}>
                              <input
                                type='email'
                                className='text-base'
                                value={this.state.email}
                                placeholder='Введите ваш email'
                                onChange={(e) => this.setState({email: e.target.value})}
                              />
                              <span className='error-message'>{this.state.email_error}</span>
                            </div>
                          )
                        }
                      </div>

                      <div className='controls'>
                        <button
                          disabled={process}
                          type='button'
                          onClick={this.handlerSave}
                          className={'btn-base btn-primary' + (process ? ' process' : '')}
                        >Сохранить</button>
                      </div>
                    </div>
                  )
                }
              </div>
            </div>
          </div>
          <TransitionGroup>
            {
              isOpen &&
              <CSSTransition key={'modal-backdrop'} appear classNames='fade' timeout={300}>
                <div className='modal-backdrop full-screen' />
              </CSSTransition>
            }
          </TransitionGroup>
        </div>
      </Fragment>
    );
  }
}

CreateSearchForm.propTypes = {
  user: PropTypes.object.isRequired,
  filter: PropTypes.object.isRequired,
  domain: PropTypes.object.isRequired,
  section: PropTypes.object.isRequired,

  eventOnOpen: PropTypes.func,
  eventSubscriptionForCian: PropTypes.func,
  showAuthForm: PropTypes.func.isRequired,
  saveSearchFilter: PropTypes.func.isRequired,
  sendNotify: PropTypes.func.isRequired
};

CreateSearchForm.defaultProps = {
  eventOnOpen: () => {},
  eventSubscriptionForCian: () => {}
};

function mapStateToProps (state) {
  return {
    user: state.get('user'),
    domain: state.get('domain'),
    section: state.get('section')
  };
}

function mapDispatchToProps (dispatch) {
  return bindActionCreators({
    showAuthForm,
    saveSearchFilter,
    sendNotify: notify.notifSend
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(CreateSearchForm);



// WEBPACK FOOTER //
// ./src/ui/Controls/Subscriptions/CreateSearchForm.jsx